export const textFieldSX = {
    "& .MuiOutlinedInput-input": {
        fontSize: "12px"
    },
    "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#D6D8E0",
        borderWidth: "1px",
        borderRadius: "8px",
    },
    "& .Mui-focused": {
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#546fff !important",
            boxShadow: "0px 4px 4px 0px rgba(205, 255, 252, 0.25), 0px 1px 0px 0px rgba(38, 57, 151, 0.04), 0px 0px 0px 4px rgba(84, 111, 255, 0.12)"
        },
    },
}